import BookTourPopUp from './BookTourPopUp';

export default BookTourPopUp ;